import { DisplayDelivery } from "../../../../types/schedule/display-delivey";
import { DeliveryState } from "../../../type/delivery-state";

interface Action {
  type: string;
  payload: {
    displayDeliveries: DisplayDelivery[];
  };
}

export const setDisplayDeliveriesDispatch = (
  state: DeliveryState,
  action: Action
) => {
  const { displayDeliveries } = action.payload;
  state.displayDeliveries = displayDeliveries;
};
